<template>
  <div id="onboard-section">
    <h2>Get Started</h2>
    <a class="minor cta-link" href="#" v-if="canLaunchTour" @click="launchTour">Tour</a>

    <ol>
      <li v-for="step in steps" :class="{fulfilled: step.done, todo: !step.done, active: step.active}" :key="step.key"
        @click="onClickStep(step)">{{step.title}}</li>
    </ol>
  </div>
</template>

<style lang="scss" scoped>
li.fulfilled {
  list-style: disc inside url("/static/images/dashboard/icon_greencheck.svg");
}
li.todo {
  list-style: disc inside url("/static/images/dashboard/icon_rightarrow.svg");
  cursor: pointer;
}
li.active {
  border-width: 4px;
  padding: calc(0.5em - 2px) calc(0.6em - 2px);
  background: #eff;
}
li {
  border: 2px solid #acc;
  border-radius: 5px;
  padding: 0.3em 1em;
  margin: 1em 0;
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
import {launchTourClicked} from '@/lib/track/events';
export default {
  computed: {
    ...mapGetters(['flags', 'steps', 'heroState']),
    canLaunchTour() {
      // If userpilot is installed we can launch the tour
      return !!window.userpilot;
    }
  },
  methods: {
    ...mapActions(['setInitialHeroState', 'setHeroState', 'nextHeroState', 'hideOnboarding']),
    onClickStep(step) {
      if (step.done) return;
      this.setHeroState(step.key);
    },
    launchTour() {
      launchTourClicked('156270243pNpy4853');
      window.userpilot.trigger('156270243pNpy4853');
    }
  },
  mounted() {
    this.setInitialHeroState();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/home/OnboardSection.vue